import React from "react";
import {graphql} from "react-apollo";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./ReasonForm";
import {cancelRemoveProductFromShop} from "../../../actions/InventoryApiActions";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";
import {validatePresence} from "../../../lib/Validators";
import {Map} from "immutable";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "reason");
  return errors.toJS();
}

class RemoveProductFromShopContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let transValues = values.set("shopId", this.props.shopId)
                            .set("productSku", this.props.productId);
    return this.props.removeProductFromShop(transValues.toJS())
      .then((response) => {
        if (response.data.removeProductFromShop.errors.length <= 0) {
          this.props.cancelRemoveProductFromShop();
        } else {
          let errors = createValidationErrors(response.data.removeProductFromShop.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        console.warn(err);
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelRemoveProductFromShop();
  }

  render() {
    return (
      <Form
        productId={this.props.productId}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const REMOVE_PRODUCT_FROM_SHOP = gql`
  mutation removeProductFromShop($data: ProductFromShopInput!) {
    removeProductFromShop(input: $data) {
      errors { key message }
    }
  }
`;

const withQuery = graphql(REMOVE_PRODUCT_FROM_SHOP, {
  props: ({mutate}) => ({
    removeProductFromShop: (data) => mutate({
      variables: { data: data },
      update: (proxy, {data: {removeProductFromShop }}) => {
        proxy.writeFragment({
          id: `${data.shopId}-${data.productSku}`,
          fragment: gql`
            fragment adam on ShopProduct {
              productTitle
              __typename
            }
          `,
          data: {
            productTitle: "-deleted-",
            __typename: "ShopProduct"
          }
        })
      }
    })
  })
});

export default connect(null, {cancelRemoveProductFromShop})(withQuery(RemoveProductFromShopContainer));